<template>
  <list-layout :tableTools='false'>
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
        <el-form ref="ruleForm" :rules="rules" :model="form" class="flex-1">
          <el-form-item prop="issuer">
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template slot='table-core'>
      <base-table-pagination v-if="!isLower1650 || isLower1024"
        :total='pagination.total'
        :currentPage='pagination.currentPage'
        :perPage='pagination.pageSize'
        @changeCurrentPage='changeCurrentPage'
        @changePerPage='changePerPage'
      ></base-table-pagination>
      <base-table-pagination-mini v-else
        :total='pagination.total'
        :currentPage='pagination.currentPage'
        :perPage='pagination.pageSize'
        @changeCurrentPage='changeCurrentPage'
        @changePerPage='changePerPage'
      ></base-table-pagination-mini>
      <div class="flex flex-row md:flex-col w-100">
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot='table-tags'>
      <base-table-filter-tags :tags="tags" hide-save @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot='table-component'>
      <kendo-grid-component
        v-model="form.issuer"
        single select-on-row-click
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :selectedField="selectedField"
        value-key="IdCIFEmpresa"
        @datastatechange="dataStateChange"
        @selectionchange="onSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot='layout-extend'>
      <reset-dialog custom-class="min-width-dialog" :dialogOpen='ResetDialog' :mobile-version="isLower1024" @toggleDialog='toggleReset' @applyDialog='setIssuer'/>
      <filter-panel :panelOpen='filterPanel' @togglePanel='toggleFilters' @applyFilters='applyFiltersHandler' />
      <slot name="layout-extend" />
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'
import { getCompaniesExtended } from '@/services/companies/getCompaniesExtended'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/Step0Filter.vue'
import ResetDialog from '@/components/Step1ResetDialog.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'

import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter-multiple'

export default {
  name: 'step0-issuer',
  components: {
    // Loading,
    ListLayout,
    FilterPanel,
    ResetDialog,
    KendoGridComponent,
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      // Searches
      saveSearchDialog: false,
      // All
      multipleFilters: TIPOS_FILTER_MULTIPLE,
      showModalGrouping: false,
      loadingExcel: false,
      spanish: true,
      showModal: false,
      ResetDialog: false,
      showModalReset: false,
      processMessage: i18n.t('invoices.invoices_issuing.step0.modal_message'),
      newIssuer: '',
      oldIssuer: '',
      vuexnamespace: 'invoicesIssuing/0',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      rules: {
        issuer: [
          {
            required: true,
            message: i18n.t('app.select_data'),
            trigger: ['blur', 'change']
          }
        ]
      },
    }
  },
  computed: {
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterIssuing']
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isLower1650: function () {
      return this.$store.getters['app/getIsLower1650']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingCompanies || this.loadingCompanyData || this.loadingContacts
    },
    tags: function () {
      var tags = this.$store.getters[this.vuexnamespace + '/getTags']
      if (this.status !== undefined && this.status !== 99999) {
        tags = tags.filter(x => x[0] !== 'estadoExtra')
      }
      return tags
      // return this.status === undefined || this.status === 99999 ? tags : tags.filter(x => x[0] !== 'estadoExtra')
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
  },
  watch: {
    actualFilterNav: async function () {
      if (this.actualFilterNav === null || this.actualFilterNav === undefined || this.actualFilterNav === '') {
        await this.removeAllTagsHandler()
      }
    },
  },
  async mounted () {
    if (this.actualFilterNav && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    } else {
      await this.removeAllTagsHandler()
    }
    this.prepareStep()
  },
  methods: {
    prepareStep: async function () {
      this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
      if (this.actualFilterNav && this.isClientFilterActive) {
        const filter = this.masterFilters
        filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      }
      this.data = await this.applyFilters()
    },
    resetForm: function () {
      this.form.issuer = ''
      this.mapSelectionKendoGrouping(false)
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        if (valid && doInput && (this.isFirstStep || this.value === '') && [3, 7, 8].includes(this.role)) {
          this.$emit('input', this.selected[0]?.idCliente ?? '')
        }
        callback(valid) 
      })
    },
    toggleReset: function () {
      this.ResetDialog = !this.ResetDialog
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      return {
        idDistribuidor: data.distribuidor ? data.distribuidor.value.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value.idCliente : null,
        CIF: data.cif ? data.cif.value : null,
        razonSocial: data.name ? data.name.value : null,
        direccion: data.direccion ? data.direccion.value : null,
        registro_mercantil: data.registro_mercantil ? data.registro_mercantil.value : null,
        email: data.email ? data.email.value : null,
        codigoPostal: data.codigo_postal ? data.codigo_postal.value : null,
        telefono: data.telefono ? data.telefono.value : null,
        codigoPais: data.pais ? data.pais.value : null,
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.respuesta

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }

      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getCompaniesExtended(orders, params)
      if (data.blnError === true) {
        this.doFeedback(`${data.msgError} [${data.codError}]`)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    removeAllTagsHandler: async function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    setIssuer: async function (cancelReset = false) {
      if (cancelReset) {
        this.selected = this.oldIssuer
      } else {
        await this.$parent.$parent.$parent.resetForm()
        this.selected = this.newIssuer
        this.form.issuer = this.newIssuer
        this.$parent.$parent.$parent.idCliente = this.newIssuer.IdCliente
        this.validate(undefined, true)
      }
      this.data = await this.applyFilters()
    },
    onSelectionChange: async function ({ selected }) {
      this.newIssuer = selected[0]
      this.oldIssuer = this.form.issuer
      if (this.oldIssuer === '') {
        this.selected = selected
        this.form.issuer = this.selected[0] ? this.selected[0]: ''
        this.validate(undefined, true)
      } else if (this.newIssuer !== this.oldIssuer) {
        this.toggleReset()
      }
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    }
  },
}
</script>

<style>

</style>
